/** saves Accounts Balances
@payload { Array } - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_accountsbalances
*/
export const SAVE_ACCOUNTS_BALANCE = (state, payload) => {
    state.accountsBalances = payload.balanceViews
}

/** saves list of Recurring Transfers
@payload { Array } - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_transfersrecurring
*/
export const SAVE_RECURRING_TRANSFERS = (state, { pageNumber, data }) => {
    state.recurringTransfers = pageNumber === 1 ? data.transfers : state.recurringTransfers.concat(data.transfers)

    state.lastRecurringTransfersInfo = {
        currentPageToken: data.currentPageToken
    }
    state.recurringTransfersHasMore = data.hasMore
}

/** saves Accounts Balances
@payload { Array } - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_accountsbalances
*/
export const SAVE_BENEFICIARY_NAME = (state, payload) => {
    state.beneficiaryName = payload.firstHolderName
}

/** saves Schedule Types
@payload { Array } - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_transfersscheduleTypes
*/
export const SAVE_SCHEDULE_TYPES = (state, payload) => {
    state.scheduleTypes = payload
}

/* ***********************************************
*                  CLEAR MUTATIONS               *
*********************************************** */
export const CLEAR_FEATURE_STATE = (state, payload) => {
    state.accountsBalances = []
    state.recurringTransfers = []
    state.scheduleTypes = []
    state.lastRecurringTransfersInfo = {}
    state.recurringTransfersHasMore = false
    state.beneficiaryName = null
}
